import React, { useContext, useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import ScrollToTop from './components/shared/ScrollToTop';
import Loader from './components/shared/Loader';
import LoginContainer from './components/shared/users/LoginContainer';
import Register from './components/shared/users/Register';
import Profile from './components/shared/users/Profile';
import AdminLogin from './components/admin/AdminLogin';
import PrivateRoute from './components/shared/PrivateRoute';
import Dashboard from './components/admin/Dashboard';
import Orders from './components/admin/Orders';
import Inicio from './components/client/Inicio';
import ProductList from './components/client/ProductList';
import SingleProduct from './components/client/SingleProduct';
import ProductoAIList from './components/client/ProductoAIList';
import Cart from './components/client/Cart';
import Checkout from './components/client/Checkout';
import OrderSuccess from './components/client/OrderSuccess';
import OrderFailure from './components/client/OrderFailure';
import OrderPending from './components/client/OrderPending';
import Contact from './components/client/Contact';
import Menu from './components/client/Menu';
import Footer from './components/client/Footer';
import ChatWidget from './components/shared/ChatWidget';
import MaintenancePage from './components/client/MaintenancePage';
import { AuthContext } from './providers/AuthContext';
import { CategoryProvider, CategoryContext } from './providers/CategoryContext';
import { ConfigProvider } from './providers/ConfigContext';

function MaintenanceGuard({ isAdminAuthenticated, children }) {
  const [maintenance, setMaintenance] = useState(false);
  const [checked, setChecked] = useState(false);
  const location = useLocation();

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/store-config`)
      .then(r => r.json())
      .then(data => {
        setMaintenance(data?.data?.maintenanceMode === true);
      })
      .catch(() => {})
      .finally(() => setChecked(true));
  }, []);

  const isAdminPath = location.pathname.startsWith('/admin') || location.pathname.startsWith('/dashboard') || location.pathname.startsWith('/orders');

  if (!checked) return null;
  if (maintenance && !isAdminAuthenticated && !isAdminPath) return <MaintenancePage />;
  return children;
}

function AppContent() {
  const { user, isAdminAuthenticated } = useContext(AuthContext);
  const { loading: categoriesLoading } = useContext(CategoryContext);

  // Esperamos a que las categorías carguen para armar el menú completo
  if (categoriesLoading) return <Loader />;

  return (
    <Router>
      <ScrollToTop />
      <MaintenanceGuard isAdminAuthenticated={isAdminAuthenticated}>
      <Menu isAdminAuthenticated={isAdminAuthenticated} />
      <Routes>
        <Route path="/" element={<Inicio />} />
        <Route path="/tienda" element={<ProductList />} />
        <Route path="/productoai/:clientId" element={<ProductoAIList />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/product/:id" element={<SingleProduct />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/success" element={<OrderSuccess />} />
        <Route path="/orden-confirmada" element={<OrderSuccess />} />
        <Route path="/failure" element={<OrderFailure />} />
        <Route path="/pending" element={<OrderPending />} />
        <Route path="/contacto" element={<Contact />} />

        {/* Admin */}
        <Route path="/admin" element={<AdminLogin />} />

        {/* Usuarios */}
        <Route path="/user" element={<LoginContainer />} />
        <Route path="/register" element={<Register />} />
        <Route
          path="/profile"
          element={user ? <Profile /> : <Navigate to="/user" replace />}
        />

        {/* Rutas protegidas Admin */}
        <Route element={<PrivateRoute isAuthenticated={isAdminAuthenticated} />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/orders" element={<Orders />} />
        </Route>
      </Routes>
      <Footer />
      <ChatWidget />
      </MaintenanceGuard>
    </Router>
  );
}

function App() {
  const { loading } = useContext(AuthContext);

  // Esperamos a que Firebase confirme el estado
  if (loading) return <Loader />;

  return (
    <ConfigProvider>
      <CategoryProvider>
        <AppContent />
      </CategoryProvider>
    </ConfigProvider>
  );
}

export default App;
